import i18next from 'i18next';

i18next.addResources('es_CL', 'PopOverInfo', {
  title: 'Los estado de delivery para esta etapa pueden ser:',
  waitingStatus: 'Los estados de delivery serán visibles cuando los pedidos pasen a preparación.',
  preorder: 'Pedido en espera de confirmación en la cocina',
  confirmed: 'Delivery confirmado y a la espera de ser enviado',
  rejected: 'Delivery rechazado por datos no válidos',
  cancelled: 'Delivery cancelado por el delivery asignado',
  inProgress: 'El repartidor ha sido asignado',
  nearPickup: 'El repartidor está cerca de la tienda',
  nearDropoff: 'El repartidor está cerca de entregar el pedido',
  pickedUp: 'El repartidor ha recolectado el pedido en la tienda'
});

i18next.addResources('es_CR', 'PopOverInfo', {
  title: 'Los estado de delivery para esta etapa pueden ser:',
  waitingStatus: 'Los estados de delivery serán visibles cuando los pedidos pasen a preparación.',
  preorder: 'Pedido en espera de confirmación en la cocina',
  confirmed: 'Delivery confirmado y a la espera de ser enviado',
  rejected: 'Delivery rechazado por datos no válidos',
  cancelled: 'Delivery cancelado por el delivery asignado',
  inProgress: 'El repartidor ha sido asignado',
  nearPickup: 'El repartidor está cerca de la tienda',
  nearDropoff: 'El repartidor está cerca de entregar el pedido',
  pickedUp: 'El repartidor ha recolectado el pedido en la tienda'
});
